import request from '../../utils/request'
//发送邮箱验证
export function getEmailCode(data) {
  return request({
    url: '/account/verify',
    method: 'post',
    params: data

  })
}
//注册
export function register(data) {
  return request({
    url: '/account/register',
    method: 'post',
    params: data
  })
}
//重置密码
export function forgetPw(data) {
  return request({
    url: '/account/forgetPw',
    method: 'post',
    params: data
  })
}
//登录
export function login(data) {
  return request({
    url: '/account/login',
    method: 'post',
    params: data
  })
}
//google/facebook登录
export function otherLogin(type) {
  return request({
    url: `account/oauth/${type}`,
    method: 'post',
  })
}
//获取用户详情
export function getUserInfo() {
  return request({
    url: `/user/info`,
    method: 'get',
  })
}
//获取我的雜誌列表
export function getMyMagazineList(query) {
  return request({
    url: '/user/order',
    method: 'get',
    params: query
  })
}


// WEBPACK FOOTER //
// ./src/assets/api/login.js